<mat-spinner *ngIf="!loaded" diameter="50"></mat-spinner>

<div class="approaches-container" *ngIf="loaded">
  <div class="save-header">
    <h2 data-test="title-approaches">Treatment approaches</h2>
  
    <div>
      <iris-button
        (click)="onCancel()"
        [disabled]="saving || approachesForm?.pristine"
        [buttonType]="irisButtonTypes.SECONDARY"
        aria-label="Cancel"
        data-test="cancel-treatment-approaches-changes"
      >
        Cancel
      </iris-button>
      <iris-button
        (click)="onSave()"
        [disabled]="saving || approachesForm?.pristine"
        aria-label="Save"
        data-test="save-treatment-approaches-changes"
      >
        Save
      </iris-button>
    </div>
  </div>

  <p class="iris-body-responsive">While optional to include on your profile, sharing your approaches to treatment can help to accurately reflect your experience, skills, and what therapy will be like for potential clients. All treatment approaches you choose below will display on your profile and will be used in matching.</p>

  <iris-card>
    <form [formGroup]="approachesForm" data-test="other-treatment-approaches">
      <iris-form-field
        label="Treatment approaches"
        [showOptionalTag]="false"
        helperText="You can choose up to 15 treatment approaches"
      >
        <sondermind-grid-layout
          formGroupName="approaches"
          [refDatumItems]="approaches"
        >
          <iris-checkbox
            *ngFor="let approach of approaches"
            [formControlName]="approach.id.toString()"
            [attr.data-test]="'list-checkbox-' + approach.title"
          >
            {{ approach.title }}
          </iris-checkbox>
        </sondermind-grid-layout>
      </iris-form-field>
    </form>
  </iris-card>
</div>
